import { Button, CircularProgress } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { ReactComponent as TokenIcon } from '../../../assets/token.svg';
import React, { FC } from 'react';
import { useApolloClient, useMutation } from '@apollo/react-hooks';
import {
  CreateNextCloudFolder,
  CreateNextCloudFolderVariables,
} from '../../../graphql/user/types/CreateNextCloudFolder';
import { CREATE_NEXT_CLOUD_FOLDER } from '../../../graphql/user/mutation';
import { displaySnackBar } from '../../../common/displaySnackbar';
import CheckIcon from '@material-ui/icons/Check';

interface ICreateNextCloudFolderButton {
  userId: number;
  directoryToken: string | null;
  disabled: boolean;
}

const CreateNextCloudFolderButton: FC<ICreateNextCloudFolderButton> = (
  props,
) => {
  const { userId, directoryToken, disabled } = props;

  const client = useApolloClient();

  const [createNextCloudFolder, { loading }] = useMutation<
    CreateNextCloudFolder,
    CreateNextCloudFolderVariables
  >(CREATE_NEXT_CLOUD_FOLDER, {
    onCompleted: (data) => {
      if (data?.createNextCloudFolder) {
        displaySnackBar(client, {
          type: 'SUCCESS',
          isOpen: true,
          message: `Token créé pour ${data.createNextCloudFolder.email}`,
        });
      }
    },
  });

  const handleCreateToken = (userId: number) => {
    createNextCloudFolder({ variables: { userId } });
  };

  if (directoryToken)
    return <CheckIcon color="disabled" width={24} height={24} />;

  return (
    <Tooltip title="Cliquez-moi">
      <Button
        disabled={loading || disabled}
        onClick={() => handleCreateToken(userId)}>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <TokenIcon fill={disabled ? 'grey' : 'red'} width={24} height={24} />
        )}
      </Button>
    </Tooltip>
  );
};

export default CreateNextCloudFolderButton;
